import { Box, Flex } from '@theme-ui/components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from '@emotion/styled';
import { graphql, useStaticQuery } from 'gatsby';
import { colors } from '../../../styles/theme';

const G2ReviewsSection = ({ backgroundColor }) => {
	const { g2Badge1, g2Badge2, g2Badge3, g2Badge4, g2Badge5, g2Badge6 } =
		useStaticQuery(graphql`
		{
		  g2Badge1: file(relativePath: { eq: "g2c/badge1.png" }) {
			childImageSharp {
			  gatsbyImageData(quality: 90, height: 200, layout: CONSTRAINED)
			}
		  }
		  g2Badge2: file(relativePath: { eq: "g2c/badge2.png" }) {
			childImageSharp {
			  gatsbyImageData(quality: 90, height: 200, layout: CONSTRAINED)
			}
		  }
		  g2Badge3: file(relativePath: { eq: "g2c/badge3.png" }) {
			childImageSharp {
			  gatsbyImageData(quality: 90, height: 200, layout: CONSTRAINED)
			}
		  }
		  g2Badge4: file(relativePath: { eq: "g2c/badge4.png" }) {
			childImageSharp {
			  gatsbyImageData(quality: 90, height: 200, layout: CONSTRAINED)
			}
		  }
		  g2Badge5: file(relativePath: { eq: "g2c/badge5.png" }) {
			childImageSharp {
			  gatsbyImageData(quality: 90, height: 200, layout: CONSTRAINED)
			}
		  }
		  g2Badge6: file(relativePath: { eq: "g2c/badge6.png" }) {
			childImageSharp {
			  gatsbyImageData(quality: 90, height: 200, layout: CONSTRAINED)
			}
		  }
		}
	  `);

	const g2Banners = [g2Badge1, g2Badge2, g2Badge3, g2Badge4, g2Badge5, g2Badge6];

	return (
		<Flex sx={{ ...styles.container, backgroundColor: backgroundColor ? backgroundColor : null }}>
			<Flex sx={styles.flex}>
				{g2Banners.map((banner, i) => (
					<Box
						key={"banner-" + i}
					>
						<StyledImage
							image={getImage(banner)}
							alt={`G2crowd Badge ${i + 1}`}
							imgStyle={{ objectFit: "contain" }}
						/>
					</Box>
				))}
			</Flex>
		</Flex>
	);
};

const styles = {
	flex: {
		flexWrap: "wrap",
		justifyContent: "center",
		alignItems: "center",
		mx: "auto",
	},
	container: {
		py: "1.5rem",
		bg: colors.secondaryOrange100,
		justifyContent: "center",
		alignItems: "center",
		mx: "auto",
		flexDirection: "column",
		width: ["25.188rem", "25.188rem", "44rem", "61.5rem"],
		"@media screen and (min-width: 900px) and (max-width: 1010px)": {
			width: "55.625rem",
		},
		"@media screen and (min-width: 600px) and (max-width: 710px)": {
			width: "37.5rem",
		},
		"@media(max-width: 390px)": {
			width: "20rem",
		},
	},
};

const StyledImage = styled(GatsbyImage)`
	height: 9.188rem;
	@media (max-width: 899px) and (min-width: 600px) {
	  height: 7.063rem;
	}
  `;

export default G2ReviewsSection;
